import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en', // Якщо мова не знайдена – використовувати англійську
    debug: true,
    returnEmptyString: false, 
    interpolation: { escapeValue: false },

    ns: ['translation'], // Вказуємо простір імен (namespace)
    defaultNS: 'translation', // Простір імен за замовчуванням

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Переконайтеся, що цей шлях правильний
    },
  });

export default i18n;
